/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';

import {TARGETING_IMPORTS} from '../targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-targeting-ad-unit-summary',
  template: `
    <div>
      <strong *ngIf="negated">NOT:&nbsp;</strong>
      <ng-container *ngFor="let adUnit of displayedAdUnits; let last = last">
        <a *ngIf="linkTargets && adUnit?.url" uiSref="app.inv.ad-units.ad-unit" [uiParams]="{id: adUnit?.id}">{{adUnit?.name}}</a>
        <span *ngIf="!linkTargets || !adUnit?.url">{{adUnit?.name}}</span><span *ngIf="!last">, </span>
      </ng-container>
      <div *ngIf="restricted && isLimited"><a class="show-hide-link" (click)="liftRestriction()"><span class="fa fa-chevron-down"></span>Show all</a></div>
    </div>
  `
})
export class AdUnitSummaryComponent implements OnChanges {
  @Input() targets: any;
  @Input() linkTargets = false;

  negated = false;
  restricted = true;
  isLimited = false;
  displayedAdUnits: any[] = [];
  private data: any[] = [];
  private readonly quantity = 10;

  ngOnChanges(): void {
    const target = this.targets || {};
    this.negated = target.negated;
    this.data = target.adUnits || [];
    this.restricted = true;
    this.updateDisplay();
  }

  liftRestriction(): void {
    this.restricted = false;
    this.updateDisplay();
  }

  private updateDisplay(): void {
    this.displayedAdUnits = this.restricted ? this.data.slice(0, this.quantity) : this.data;
    this.isLimited = this.data.length > this.quantity;
  }
}
